import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Package, AlertTriangle } from 'lucide-react';
import { MOCK_PRODUCTS } from '@/lib/adapters/mockData';
import type { FilterState } from '../GlobalFilters';

interface StockCoverageTabProps {
  clientId: string;
  filters: FilterState;
}

export function StockCoverageTab({ clientId, filters }: StockCoverageTabProps) {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center">
            <Package className="mr-2 h-5 w-5" />
            Couverture Stock par Produit
          </CardTitle>
          <CardDescription>
            Analyse des niveaux de stock et prévisions de rupture
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            {MOCK_products.map((product) => {
              const coverage = Math.floor(Math.random() * 45) + 7;
              const status = coverage < 14 ? 'critical' : coverage < 30 ? 'warning' : 'good';
              
              return (
                <div key={product.asin} className="flex items-center justify-between p-3 border rounded-lg">
                  <div>
                    <h4 className="font-medium">{product.title}</h4>
                    <p className="text-sm text-muted-foreground">{product.asin}</p>
                  </div>
                  <div className="text-right space-y-1">
                    <div className="font-medium">{product.stock} unités</div>
                    <Badge variant={status === 'critical' ? 'destructive' : status === 'warning' ? 'secondary' : 'default'}>
                      {coverage} jours de couverture
                    </Badge>
                  </div>
                </div>
              );
            })}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

const MOCK_products = MOCK_PRODUCTS;